//deps
import React, { memo } from "react";

//components
import BoltLottie from "./BoltLottie";
import ExpressLottie from "./ExpressLottie";
import { isEmpty } from "@swiggy-private/js-utils";
import HeaderLottie from "./HeaderLottie";
import { LottieSectionProps } from "@swiggy-private/cart-types";

const LottieSection = memo(function LottieSection({
    isBolt,
    startAnimation,
    showFinalState,
    boltSla,
    isRangeSla,
    setBoltOrExpressLottieShown,
    isCartHeaderTypeLottie,
    cartType,
    lottieArray,
    isBlack,
    isExpress,
    isOtg,
    setHeaderLottieShown,
}: LottieSectionProps) {
    if (!startAnimation || showFinalState) {
        return null;
    }

    if (!isEmpty(cartType) && isCartHeaderTypeLottie) {
        return (
            <HeaderLottie setHeaderLottieShown={setHeaderLottieShown} lottieArray={lottieArray} cartType={cartType} />
        );
    }

    if (isBolt && boltSla) {
        return (
            <BoltLottie
                sla={boltSla}
                showBoltLottie={startAnimation}
                isRangeSla={isRangeSla}
                setBoltLottieShown={setBoltOrExpressLottieShown}
            />
        );
    }

    if (isBlack && (isExpress || isOtg)) {
        return <ExpressLottie showExpressLottie={startAnimation} setExpressLottieShown={setBoltOrExpressLottieShown} />;
    }

    return null;
});

export default memo(LottieSection);
